import { render, staticRenderFns } from "./personnel_decoration.vue?vue&type=template&id=09d4873c&scoped=true&"
import script from "./personnel_decoration.vue?vue&type=script&lang=js&"
export * from "./personnel_decoration.vue?vue&type=script&lang=js&"
import style0 from "./personnel_decoration.vue?vue&type=style&index=0&id=09d4873c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d4873c",
  null
  
)

export default component.exports